import { ButtonsActionsCollaborator } from "./ButtonsActionsCollaborator";
import { CollaboratorStatusChip } from "./CollaboratorStatusChip";
import { CollaboratorNameCell } from "./CollaboratorNameCell";
import { RosterRow } from "../../../hooks/useCollaboratorRoster";
import { TranslateFn } from "../../../utils/types";

/**
 * Colonnes de la liste des collaborateurs.
 *
 * Prend `t` en argument plutot que d'etre une constante de module : une
 * constante est evaluee une seule fois, a l'import, et resterait figee dans la
 * langue active au demarrage. Les en-tetes etaient de surcroit ecrits en
 * francais en dur, sans jamais passer par i18next. Meme convention que
 * getColumnsListVehicle.
 */
export const getColumnsCollaborator = (t: TranslateFn) => [
  {
    header: t("vehicule.status", "Status"),
    field: "status",
    render: (row: Record<string, any>) => (
      <CollaboratorStatusChip row={row as RosterRow} />
    ),
  },
  {
    header: t("collaborator.name", "Last name"),
    field: "lastname",
    // The name is the click target for opening the sheet. Invitations have no
    // sheet to open (no company_user row exists yet), so the cell renders them
    // as plain text rather than a dead link.
    render: (row: Record<string, any>) => (
      <CollaboratorNameCell row={row as RosterRow} />
    ),
  },
  { header: t("collaborator.email", "Email"), field: "email" },
  { header: t("collaborator.department", "Department"), field: "department" },
  { header: t("vehicule.vehicle", "Vehicle"), field: "model" },
  { header: t("vehicule.brand", "Brand"), field: "brand" },
  {
    header: "",
    field: "",
    render: (row: Record<string, any>) => (
      <ButtonsActionsCollaborator collaborator={row as RosterRow} />
    ),
  },
];
